module.exports = __webpack_public_path__ + "img/img (24).35ab13a8.jpg";